// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_kt-0";